/* Raghu  26/10/2022   3075154998   Inputfields Alignments and Enhancements */
/* Rohini  28/10/2022   3075154998   Inputfields Alignments and Enhancements
Suresh Peddavoora 11/03/2022 3075154998 Text fields Tab Responsive Fixes */
import React, {useState, useContext, useEffect} from 'react';
import {Form, Formik} from 'formik';
import {Button, Grid, TextField} from '@material-ui/core';
import ErrorBoundaryForComponents from '../../../../../util/ErrorBoundaryForComponents';
import MediaTypeSearchTable from './MediaTypeSearchTable';
import {ThemeContext} from '../../../../../themes/ThemeProvider';
import {useSelector} from 'react-redux';
import {
  ErrorSnackbar,
  SuccessSnackbar,
  WarningSnackbar,
} from '../../../../../components/CustomSnackBar';
import PageLoader from '../../../../../components/PageLoader';
const SearchMediaTypeContainer = ({
  setTabValue,
  setCode,
  handleClose,
  setSelectedMediaTypeName,
  mediaName,
  setMediaName,
  setIsCopyData,
  disableCopy,
  setDisableCopy,
  setUsageState,
  usageState,
}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const [searchData, setSearchData] = useState([]);
  const [submit, setSubmit] = useState(false);
  const [usage, setUsage] = useState(false);
  const [customError, setCustomError] = useState(false);
  const [deleteUsage, setDeleteUsage] = useState(false);
  const [userMetrixDelete, setUserMetrixDelete] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const {isLoading, successMsg, errorMsg} = useSelector(({printusage}) => printusage);
  const {usageMedial} = useSelector(({addMediaType}) => addMediaType);
  const [isUsage, setIsUsage] = useState(false);

  useEffect(() => {
    usage && usageMedial?.userMetrix === 'No' ?
      setCustomError(true) :
      usage && usageMedial?.userMetrix === 'Yes' ?
        setTabValue(2) :
        null;

    deleteUsage && usageMedial?.userMetrix === 'No' ?
      (setUserMetrixDelete(false), setIsDelete(true)) :
      deleteUsage && usageMedial?.userMetrix === 'Yes' ?
        (setUserMetrixDelete(true), setIsUsage(true)) :
        null;

    setTimeout(() => {
      setCustomError(false);
    }, 3000);
  }, [usageMedial]);

  const handleSubmit = (data) => {
    setSearchData(data);
    setSubmit(true);
  };
  const initialValues = {
    mediaTypeName: '',
    description: '',
  };

  const onClear = () => {
    const data = {
      mediaTypeName: '',
      description: '',
    };
    setSearchData(data);
  };

  return (
    <>
      <div>
        <Formik
          onSubmit={(values) => handleSubmit(values)}
          initialValues={initialValues}
          enableReinitialize
        >
          {(props) => {
            const {values, handleChange, handleBlur, handleReset} = props;
            return (
              <div className={classes.ruleGroupCard}>
                <Form autoComplete="off" noValidate>
                  <div>
                    <ErrorBoundaryForComponents>
                      <Grid className="form-row global-field-textfields" container spacing={2}>
                        <Grid item sm={6} md={4} lg={4} xl={3} className="form-group">
                          <TextField
                            margin="dense"
                            className={` ${classes.labelName} ${classes.inputLabel}`}
                            variant="standard"
                            placeholder={`Enter Media Type Name`}
                            label="Media Type Name"
                            name="mediaTypeName"
                            value={values.mediaTypeName}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            fullWidth
                          />
                        </Grid>
                        <Grid item sm={6} md={5} lg={5} xl={6} className="form-group">
                          <TextField
                            className={` ${classes.labelName} ${classes.inputLabel}`}
                            margin="dense"
                            variant="standard"
                            name="description"
                            placeholder={`Enter Description`}
                            label="Description"
                            value={values.description}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            fullWidth
                          />
                        </Grid>
                        <Grid item sm={6} md={3} lg={3} xl={3} className="form-group">
                          <div className="d-flex align-items-center justify-content-end">
                            <Button
                              variant="outlined"
                              className={`reset-btn  mx-1 ${classes.buttonRoot}`}
                              onClick={() => {
                                handleReset();
                                setSearchData({});
                                setSubmit(true);
                                onClear();
                              }}
                            >
                              Clear
                            </Button>
                            <Button
                              type="submit"
                              variant="outlined"
                              className={`search-btn mx-1  ${classes.buttonRoot}`}
                            >
                              Search
                            </Button>
                          </div>
                        </Grid>
                      </Grid>
                    </ErrorBoundaryForComponents>
                  </div>
                </Form>
              </div>
            );
          }}
        </Formik>
        <MediaTypeSearchTable
          setTabValue={setTabValue}
          mediaName={mediaName}
          setMediaName={setMediaName}
          searchData={searchData}
          setSearchData={setSearchData}
          handleClose={handleClose}
          setCode={setCode}
          setSelectedMediaTypeName={setSelectedMediaTypeName}
          submit={submit}
          setSubmit={setSubmit}
          disableCopy={disableCopy}
          setIsCopyData={setIsCopyData}
          setUsageState={setUsageState}
          usageState={usageState}
          setUsage={setUsage}
          setDeleteUsage={setDeleteUsage}
          userMetrixDelete={userMetrixDelete}
          isDelete={isDelete}
          setIsDelete={setIsDelete}
          isUsage={isUsage}
          setIsUsage={setIsUsage}
        />
      </div>
      {isLoading && <PageLoader />}
      {errorMsg && <ErrorSnackbar errorMsg={errorMsg} />}
      {successMsg && <SuccessSnackbar successMsg={successMsg} />}
      {customError && <WarningSnackbar errorMsg={'This logic block is not being used anywhere'} />}
    </>
  );
};
export default SearchMediaTypeContainer;
